import { Alert, AlertTitle, Box } from '@mui/material';
import { Button, FormNumericField, FormTextField, Grid, Typography } from 'ui';
import { messaging } from 'types';
import ClowncarHeaderV2 from 'components/ClowncarHeaderV2';

import { Form, Formik } from 'formik';
import { useActions } from 'utils/connect';
import ClowncarBodyV2 from 'components/ClowncarBodyV2';
import React from 'react';

interface NotifyRequestFields {
  patronId: number;
  clientType: string;
  title: string;
  body: string;
  deepLinkUrl: string;
  notificationType: string;
}
const NotificationsRoute: React.FC<{}> = () => {
  const { actions } = useActions();
  const [submitting, setSubmitting] = React.useState(false);
  const [latestResponse, setLatestResponse] = React.useState<messaging.NotifyRequest>(undefined);

  return (
    <div className="Content">
      <ClowncarHeaderV2 heading={`Notifications`} />

      <div className="Main">
        <ClowncarBodyV2 isLoading={false}>
          <Box margin={2}>
            <Typography variant="heading1Medium" mb={2}>
              Send a push notification
            </Typography>
            <Typography>
              Manually send a mobile push notification to a patron for debugging purposes. The
              patron must have registered FCM tokens for messages to be deliverable.
            </Typography>
          </Box>
          <Box margin={2}>
            <Formik<NotifyRequestFields>
              initialValues={{
                patronId: 0,
                clientType: 'CONSUMER_APP',
                title: '',
                body: '',
                deepLinkUrl: '',
                notificationType: 'WAITLIST_NOTIFICATION',
              }}
              onSubmit={(values) => {
                setSubmitting(true);
                actions.notifications.sendNotification(values).then((response) => {
                  setSubmitting(false);
                  setLatestResponse(response.payload as messaging.NotifyResponse);
                });
              }}
            >
              {() => (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <FormNumericField
                        id="patronId"
                        name="patronId"
                        label="Patron ID"
                        placeholder=""
                        helperText="The database ID of the patron to notify"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormTextField
                        id="title"
                        name="title"
                        label="Notification Title"
                        placeholder="Headline for the notification"
                        helperText="Keep this brief"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormTextField
                        id="body"
                        name="body"
                        label="Notification Body"
                        placeholder="Core content of the notification"
                        helperText="This can be longer"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormTextField
                        id="deepLinkUrl"
                        name="deepLinkUrl"
                        label="Deep Link URL"
                        placeholder="tock://something?businessID=2"
                        helperText="Used for routing when the notification is clicked"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button type="submit" disabled={submitting}>
                        Send
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
            {latestResponse && (
              <Box mt={2}>
                <Alert
                  severity={latestResponse.sentMessageId.length ? 'success' : 'warning'}
                  onClose={() => {
                    setLatestResponse(undefined);
                  }}
                >
                  <AlertTitle>Latest response</AlertTitle>
                  {latestResponse.sentMessageId.length
                    ? JSON.stringify(latestResponse)
                    : 'No messages delivered'}
                </Alert>
              </Box>
            )}
          </Box>
        </ClowncarBodyV2>
      </div>
    </div>
  );
};

export default NotificationsRoute;
